var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectArrow = function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.55c-.45 0-.9-.15-1.275-.488L.675 1.613A.694.694 0 0 1 .637.676a.694.694 0 0 1 .938-.038l10.05 9.45c.188.188.525.188.75 0l10.05-9.45c.262-.262.675-.225.938.038.262.262.224.675-.038.938l-10.05 9.412c-.375.338-.825.525-1.275.525Z",
    fill: "#163144"
  })));
};
export default SvgSelectArrow;